import * as React from 'react';

import { useApolloClient } from '@apollo/client';

import { useUser } from '@queries/useUser';

import saveShadefinderUserData from '../mutations/saveShadefinderUserData.graphql';
import { IShadefinderUserData } from '../types';

export const useSaveShadefinderUserData = (masterId: string) => {
  const client = useApolloClient();
  const { isLoggedIn } = useUser();

  const onShadefinderUserDataChanged = React.useCallback(
    async (changedUserData: Partial<IShadefinderUserData>) => {
      if (!changedUserData) {
        return;
      }

      if (!isLoggedIn) {
        return;
      }

      await client.mutate({
        mutation: saveShadefinderUserData,
        variables: {
          userData: { ...changedUserData, productId: Number(masterId) },
        },
      });
    },
    [client, isLoggedIn, masterId]
  );

  return { onShadefinderUserDataChanged };
};
